import React, {useEffect, useState} from 'react'
import axios from 'axios'
import {useSelector} from 'react-redux'
import DynamicForm from '../../../../reusable-components/forms/DynamicForm'
import {NEW_NURSES_ASSESSMENT_INPUTS} from '../../../Notes/Nurses_Notes/GENERAL_CONSTANTS'
import {Box, Typography, Button, Tabs, Tab, Paper} from '@mui/material'
import {toast} from 'react-toastify'
import {useHistory, useParams} from 'react-router-dom'
import dayjs from 'dayjs'
import {MoonLoader} from 'react-spinners'
import FormWrapper from '../../../../reusable-components/Wrapper/Wrapper'
import {AppDispatch} from '../../../../../setup/redux/Store'
import {
  NEW_NURSES_ASSESSMENT_FORM_INPUTS,
  NURSES_ASSESSMENT_FORM1_INITIAL_STATE,
  NURSES_ASSESSMENT_FORM2_INITIAL_STATE,
  NURSES_ASSESSMENT_FORM3_INITIAL_STATE,
  NURSES_ASSESSMENT_FORM4_INITIAL_STATE,
  NursesAssessmentForm1Fields,
  NursesAssessmentForm2Fields,
  NursesAssessmentForm3Fields,
  NursesAssessmentForm4Fields,
} from '../../../Notes/Nurses_Notes/GENERAL_CONSTANTS'
import {RootState} from '../../../../../setup'
import FrequencyDateRangePicker from '../../../../reusable-components/NoteType/NoteType'
import NursesAssessmentform1 from '../../../Notes/Nurses_Notes/Assessment/NursesAssessmentForms/NursesAssessmentForm1'
import NursesAssessmentForm2 from '../../../Notes/Nurses_Notes/Assessment/NursesAssessmentForms/NursesAssessmentForm2'
import NursesAssessmentForm3 from '../../../Notes/Nurses_Notes/Assessment/NursesAssessmentForms/NursesAssessmentForm3'
import NursesAssessmentForm4 from '../../../Notes/Nurses_Notes/Assessment/NursesAssessmentForms/NursesAssessmentForm4'
import {LocalizationProvider} from '@mui/x-date-pickers'
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs'

const selectTimeZone = (state: RootState) => state.timeZone.timeZone

interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}

function TabPanel(props: TabPanelProps) {
  const {children, value, index, ...other} = props

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`nurses-assessment-tabpanel-${index}`}
      aria-labelledby={`nurses-assessment-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{p: 3}}>{children}</Box>}
    </div>
  )
}

function a11yProps(index: number) {
  return {
    id: `nurses-assessment-tab-${index}`,
    'aria-controls': `nurses-assessment-tabpanel-${index}`,
  }
}

export default function DeletedNursesAssessmentForm() {
  const history = useHistory()
  const [isFormLoading, setIsFormLoading] = useState(false)
  const [activeTab, setActiveTab] = useState(0)
  const [isMobile, setIsMobile] = useState(false)
  const [formElements, setFormElements] = useState([])
  const params: {id: string} = useParams()
  const [clients, setClients] = useState([])
  const [uiElementsList, setUiElementsList] = useState([])

  const [clientId, setClientId] = useState(null)

  // Separate form data states
  const [formData, setFormData] = useState(NEW_NURSES_ASSESSMENT_FORM_INPUTS)
  const [form1Data, setForm1Data] = useState<NursesAssessmentForm1Fields>(
    NURSES_ASSESSMENT_FORM1_INITIAL_STATE
  )
  const [form2Data, setForm2Data] = useState<NursesAssessmentForm2Fields>(
    NURSES_ASSESSMENT_FORM2_INITIAL_STATE
  )
  const [form3Data, setForm3Data] = useState<NursesAssessmentForm3Fields>(
    NURSES_ASSESSMENT_FORM3_INITIAL_STATE
  )
  const [form4Data, setForm4Data] = useState<NursesAssessmentForm4Fields>(
    NURSES_ASSESSMENT_FORM4_INITIAL_STATE
  )
  const [noteData, setNoteData] = useState({
    noteType: '',
  })

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 900)
    }

    checkScreenSize()
    window.addEventListener('resize', checkScreenSize)

    return () => window.removeEventListener('resize', checkScreenSize)
  }, [])

  useEffect(() => {
    setFormElements(NEW_NURSES_ASSESSMENT_INPUTS)
    fetchData()
  }, [])

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue)
  }

  const fetchData = async () => {
    setIsFormLoading(true)
    try {
      const res = await axios.get(`/nursesAssessment/getById/${params.id}?isDeleted=true`)
      const data = res.data.result

      const response = await axios.get('/clients/getClientNames')
      const {data: clientsList} = response?.data

      const updatedClients = clientsList.map((client) => ({
        label: client.fullName,
        value: client._id,
      }))

      setClientId(data.clientId)

      // Set note data
      setNoteData({
        noteType: data.noteType,
      })

      // Map data to form1 (General Information)
      const form1MappedData = {
        clientId: data.clientId,
        assessmentDate: data.generalInformation?.assessmentDate,
        allergies: data.generalInformation?.allergies || [],
        otherAllergies: data.generalInformation?.otherAllergies,
        codeStatus: data.generalInformation?.codeStatus,
        infoSource: data.generalInformation?.infoSource,
        otherInfoSource: data.generalInformation?.otherInfoSource,
        precautions: data.generalInformation?.precautions,
        otherPrecautions: data.generalInformation?.otherPrecautions,
        t: data.generalInformation?.vitalSigns?.t,
        p: data.generalInformation?.vitalSigns?.p,
        bp: data.generalInformation?.vitalSigns?.bp,
        r: data.generalInformation?.vitalSigns?.r,
        weight: data.generalInformation?.vitalSigns?.weight,
        height: data.generalInformation?.vitalSigns?.height,
        medications: data.medications || [],
        wounds: data.dietaryScreen?.wounds,
        alternativeNutrition: data.dietaryScreen?.alternativeNutrition,
        weightdetails: data.dietaryScreen?.weightdetails,
        weightamount: data.dietaryScreen?.weightamount,
        dietaryDetails: data.dietaryScreen?.dietaryDetails || [],
      }

      // Map data to form2 (Psychosocial & Medical)
      const form2MappedData = {
        leisureInterest: data.psychosicial?.leisureInterest || [],
        socialActivities: data.psychosicial?.socialActivities,
        copingSkills: data.psychosicial?.copingSkills,
        culturalPractices: data.psychosicial?.culturalPractices,
        spiritualPractices: data.psychosicial?.spiritualPractices,
        otherPsychosocial: data.psychosicial?.otherPsychosocial,
        abuseHistory: data.psychosicial?.abuseHistory,
        selfHarm: data.psychosicial?.selfHarm,
        etohConsumption: data.psychosicial?.etohConsumption,
        drugAbuse: data.psychosicial?.drugAbuse,
        caffeineIntake: data.psychosicial?.caffeineIntake,
        tobaccoUse: data.psychosicial?.tobaccoUse,
        cessationEducation: data.psychosicial?.cessationEducation,
        medicalHistory: data.medicalDetails?.medicalHistory || [],
        lastFluVaccine: data.medicalDetails?.lastFluVaccine,
        lastPneumoniaVaccine: data.medicalDetails?.lastPneumoniaVaccine,
        prevSurgeries: data.medicalDetails?.prevSurgeries,
        prevSurgeriesDetails: data.medicalDetails?.prevSurgeriesDetails,
        followingSymptoms: data.medicalDetails?.followingSymptoms,
        transfusionReactionDetails: data.medicalDetails?.transfusionReactionDetails,
        diabeticYears: data.medicalDetails?.diabeticYears,
        diabeticTreatment: data.medicalDetails?.diabeticTreatment,
        preferredLanguage: data.medicalDetails?.preferredLanguage,
        familyCareInvolved: data.medicalDetails?.familyCareInvolved,
        educationalNeeds: data.medicalDetails?.educationalNeeds,
        patientTB: data.medicalDetails?.patientTB,
        familyTB: data.medicalDetails?.familyTB,
        bloodTransfusion: data.medicalDetails?.bloodTransfusion,
        diabetic: data.medicalDetails?.diabetic,
        glucometer: data.medicalDetails?.glucometer,
        fingerStick: data.medicalDetails?.fingerStick,
        administerInsulin: data.medicalDetails?.administerInsulin,
        interpreterNeeded: data.medicalDetails?.interpreterNeeded,
        familyAvailforTeaching: data.medicalDetails?.familyAvailforTeaching,
        response: data.neurologic?.response,
        motorResponse: data.neurologic?.motorResponse,
        verbalResponse: data.neurologic?.verbalResponse,
        affect: data.neurologic?.affect,
        otherAffect: data.neurologic?.otherAffect,
        hearing: data.neurologic?.hearing,
        vision: data.neurologic?.vision,
        gagReflex: data.neurologic?.gagReflex,
        speech: data.neurologic?.speech,
      }

      // Map data to form3 (Cardiovascular & Pulmonary)
      const form3MappedData = {
        regular: data.cardiovascular?.regular || [],
        irregular: data.cardiovascular?.irregular || [],
        strong: data.cardiovascular?.strong || [],
        weak: data.cardiovascular?.weak || [],
        chestPain: data.cardiovascular?.chestPain,
        chestPainLoc: data.cardiovascular?.chestPainLoc,
        nailBeds: data.cardiovascular?.nailBeds,
        edemafour: data.cardiovascular?.edemafour || [],
        edemafourDetails: data.cardiovascular?.edemafourDetails,
        edemathree: data.cardiovascular?.edemathree || [],
        edemathreeDetails: data.cardiovascular?.edemathreeDetails,
        edematwo: data.cardiovascular?.edematwo || [],
        edematwoDetails: data.cardiovascular?.edematwoDetails,
        edemaone: data.cardiovascular?.edemaone || [],
        edemaoneDetails: data.cardiovascular?.edemaoneDetails,
        otherCardiovascular: data.cardiovascular?.otherCardiovascular,
        cardianRhythmDetails: data.cardiovascular?.cardianRhythmDetails,
        clear: data.pulmonary?.clear || [],
        equalbilaterally: data.pulmonary?.equalbilaterally || [],
        course: data.pulmonary?.course || [],
        rales: data.pulmonary?.rales || [],
        rhonchi: data.pulmonary?.rhonchi || [],
        wheeze: data.pulmonary?.wheeze || [],
        pleural: data.pulmonary?.pleural || [],
        otherSoundDetails: data.pulmonary?.otherSoundDetails,
        cough: data.pulmonary?.cough,
        coughColor: data.pulmonary?.coughColor,
        coughQuality: data.pulmonary?.coughQuality,
        coughQuantity: data.pulmonary?.coughQuantity,
        nasalFlaring: data.pulmonary?.nasalFlaring,
        breathShortness: data.pulmonary?.breathShortness,
        ett: data.pulmonary?.ett,
        ettSize: data.pulmonary?.ettSize,
        o2: data.pulmonary?.o2,
        o2Amount: data.pulmonary?.o2Amount,
        o2Size: data.pulmonary?.o2Size,
        o2TakenVia: data.pulmonary?.o2TakenVia,
        edemanone: data.cardiovascular?.edemanone,
        otherPulmonary: data.pulmonary?.otherPulmonary,
        takenvia: data.pulmonary?.o2TakenVia,
        capillaryRefillOtherDetails: data.cardiovascular?.capillaryRefillOtherDetails,
        capillaryRefillTime: data.cardiovascular?.capillaryRefillTime,
      }

      // Map data to form4 (GI, GU & Musculoskeletal)
      const form4MappedData = {
        lastBMdate: data.gastroIntestinal?.lastBMdate,
        bowelPatterns: data.gastroIntestinal?.bowelPatterns,
        bowelSounds: data.gastroIntestinal?.bowelSounds,
        abdomen: data.gastroIntestinal?.abdomen,
        abdomenLocation: data.gastroIntestinal?.abdomenLocation,
        experiencingGI: data.genitourinary?.experiencingGI,
        urineColor: data.genitourinary?.urineColor,
        bladder: data.genitourinary?.bladder,
        catheterType: data.genitourinary?.catheterType,
        catheterSize: data.genitourinary?.catheterSize,
        catheterDate: data.genitourinary?.catheterDate,
        catheterChange: data.genitourinary?.catheterChange,
        equal: data.musculoskeletal?.muscleStrength?.muscleEqual || [],
        strong: data.musculoskeletal?.muscleStrength?.muscleStrong || [],
        weak: data.musculoskeletal?.muscleStrength?.muscleWeak || [],
        paralysis: data.musculoskeletal?.muscleStrength?.paralysis || [],
        spastic: data.musculoskeletal?.muscleStrength?.spastic || [],
        contracture: data.musculoskeletal?.muscleStrength?.contracture || [],
        flaccid: data.musculoskeletal?.muscleStrength?.flaccid || [],
        amputation: data.musculoskeletal?.muscleStrength?.amputation || [],
        bedMobility: data.musculoskeletal?.physicalImpaired?.bedMobility,
        transfers: data.musculoskeletal?.physicalImpaired?.transfers,
        gait: data.musculoskeletal?.physicalImpaired?.gait,
        balance: data.musculoskeletal?.physicalImpaired?.balance,
        comprehension: data.musculoskeletal?.communicationFunction?.comprehension,
        expression: data.musculoskeletal?.communicationFunction?.expression,
        cognition: data.musculoskeletal?.communicationFunction?.cognition,
        readingWriting: data.musculoskeletal?.communicationFunction?.readingWriting,
        grooming: data.musculoskeletal?.adlFunction?.grooming,
        feeding: data.musculoskeletal?.adlFunction?.feeding,
        bathing: data.musculoskeletal?.adlFunction?.bathing,
        dressing: data.musculoskeletal?.adlFunction?.dressing,
        assistiveDevices: data.musculoskeletal?.assistiveDevices || [],
        otherassistiveDevices: data.musculoskeletal?.otherassistiveDevices,
        skinColor: data.skinAssessment?.skinColor || [],
        skintempreture: data.skinAssessment?.skintempreture || [],
        otherskinTempDetails: data.skinAssessment?.otherskinTempDetails,
        turgor: data.skinAssessment?.turgor,
        otherTurgorDetails: data.skinAssessment?.otherTurgorDetails,
        skinTexture: data.skinAssessment?.skinTexture,
        otherskinTextureDetails: data.skinAssessment?.otherskinTextureDetails,
        sensory: data.skinAssessment?.bradenScale?.sensory,
        moisture: data.skinAssessment?.bradenScale?.moisture,
        activity: data.skinAssessment?.bradenScale?.activity,
        mobility: data.skinAssessment?.bradenScale?.mobility,
        nutrition: data.skinAssessment?.bradenScale?.nutrition,
        friction: data.skinAssessment?.bradenScale?.friction,
        skinPrecatuions: data.skinAssessment?.skinPrecatuions,
        woundTeamNotified: data.skinAssessment?.woundTeamNotified,
        diet: data.nutrition?.diet,
        dietType: data.nutrition?.dietType,
        supplements: data.nutrition?.supplements,
        howOften: data.nutrition?.howOften,
        restricitons: data.nutrition?.restricitons,
        appetite: data.nutrition?.appetite,
        tubeFeeding: data.nutrition?.tubeFeeding,
        parentalFeeding: data.nutrition?.parentalFeeding,
        experiencing: data.nutrition?.experiencing || [],
        mucosaIntact: data.nutrition?.mucosaIntact,
        tongueIntact: data.nutrition?.tongueIntact,
        dentitionIntact: data.nutrition?.dentitionIntact,
        otherdetails: data.nutrition?.otherdetails,
        communicationFunction: data.musculoskeletal?.communicationFunction || [],
        adlFunction: data.musculoskeletal?.adlFunction || [],
        otherskinDetails: data.skinAssessment?.otherskinDetails,
      }

      const transformedPainAssessment = (data.painAsessment || []).map((pain: any) => ({
        location: pain.location || '',
        rating: pain.rating || '',
        onset: pain.onset || '',
        reliefMeasures: pain.reliefMeasures || '',
        otherDetails: pain.reliefMeasuresDetails || pain.otherDetails || '',
      }))

      const additionalFormData = {
        painAsessment: transformedPainAssessment,
        painScale: data.painScale,
        fallWithinYear: data.fallRisk?.fallWithinYear || '',
        currentlyonFallPrecaution: data.fallRisk?.currentlyonFallPrecaution || '',
        vascularAcess: data.vascularAcess || [],
      }

      setForm1Data(form1MappedData)
      setForm2Data(form2MappedData)
      setForm3Data(form3MappedData)
      setForm4Data(form4MappedData)
      setFormData(additionalFormData)

      const baseForm = NEW_NURSES_ASSESSMENT_INPUTS.map((item) => {
        if (item.name === 'clientId') {
          return {
            ...item,
            options: updatedClients,
            disabled: true,
            value: data.clientId,
          }
        }
        return {...item, disabled: true}
      })

      setUiElementsList(baseForm)
      setClients(updatedClients)
    } catch (error) {
      console.error('Error fetching data:', error)
      toast.error('Failed to fetch assessment data')
    } finally {
      setIsFormLoading(false)
    }
  }

  const buttons = [{label: 'Cancel', variant: 'outlined', type: 'button'}]

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <FormWrapper
        title='Deleted Nursing Assessment'
        content={
          <>
            {isFormLoading ? (
              <div className='overlay d-flex justify-content-center' style={{marginTop: '100px'}}>
                <MoonLoader color='#9db2fc' size={60} loading={isFormLoading} />
              </div>
            ) : (
              <>
                <Typography
                  sx={{
                    fontSize: '16px',
                    fontWeight: 'bold',
                    marginBottom: '0.5rem',
                    marginLeft: '1rem',
                  }}
                  color='primary'
                >
                  Note Type
                </Typography>
                <FrequencyDateRangePicker
                  isEntry={false}
                  isTemplate={true}
                  isFullForm={false}
                  isEdit={true}
                  formData={noteData}
                  setFormData={setNoteData}
                  isDeleted={true}
                />
                <Box sx={{width: '100%', mt: 2}}>
                  <style>
                    {`
                      .deleted-form-content input[type="text"],
                      .deleted-form-content input[type="number"],
                      .deleted-form-content input[type="email"],
                      .deleted-form-content input[type="tel"],
                      .deleted-form-content textarea,
                      .deleted-form-content select,
                      .deleted-form-content .MuiInputBase-input,
                      .deleted-form-content .MuiSelect-select,
                      .deleted-form-content .MuiCheckbox-root,
                      .deleted-form-content .MuiAutocomplete-input {
                        pointer-events: none !important;
                        cursor: not-allowed !important;
                        opacity: 0.7 !important;
                      }
                      
                      .deleted-form-content .MuiInputBase-root {
                        pointer-events: none !important;
                        cursor: not-allowed !important;
                        opacity: 0.7 !important;
                      }
                      
                      .deleted-form-content .MuiFormControl-root {
                        pointer-events: none !important;
                        cursor: not-allowed !important;
                        opacity: 0.8 !important;
                      }
                      
                      .deleted-form-content .MuiFormControlLabel-root {
                        opacity: 0.8 !important;
                      }
                      
                      .deleted-form-content .MuiInputLabel-root {
                        opacity: 0.8 !important;
                      }
                    `}
                  </style>
                  <Paper elevation={1} sx={{mb: 2, ml: 2, mr: 2, borderRadius: '0px'}}>
                    <Box
                      sx={{
                        overflowX: 'auto',
                        '&::-webkit-scrollbar': {
                          height: '6px',
                        },
                        '&::-webkit-scrollbar-track': {
                          backgroundColor: '#f1f1f1',
                        },
                        '&::-webkit-scrollbar-thumb': {
                          backgroundColor: '#c1c1c1',
                          borderRadius: '3px',
                        },
                        '&::-webkit-scrollbar-thumb:hover': {
                          backgroundColor: '#a8a8a8',
                        },
                      }}
                    >
                      <Tabs
                        value={activeTab}
                        onChange={handleTabChange}
                        aria-label='nurses assessment tabs'
                        variant={isMobile ? 'scrollable' : 'fullWidth'}
                        scrollButtons={false}
                        allowScrollButtonsMobile={false}
                        sx={{
                          '& .MuiTab-root': {
                            minHeight: '48px',
                            fontSize: '14px',
                            fontWeight: 500,
                            textTransform: 'none',
                            ...(isMobile && {
                              minWidth: 'auto',
                              padding: '12px 16px',
                              whiteSpace: 'nowrap',
                            }),
                            '@media (max-width: 600px)': {
                              fontSize: '12px',
                              padding: '8px 12px',
                              minHeight: '40px',
                            },
                          },
                          '& .Mui-selected': {
                            color: '#1976d2',
                          },
                          '& .MuiTabs-indicator': {
                            backgroundColor: '#1976d2',
                          },
                        }}
                      >
                        <Tab label='General Information' {...a11yProps(0)} />
                        <Tab label='Psychosocial & Medical' {...a11yProps(1)} />
                        <Tab label='Cardiovascular & Pulmonary' {...a11yProps(2)} />
                        <Tab label='GI, GU & Musculoskeletal' {...a11yProps(3)} />
                        <Tab label='Additional Information' {...a11yProps(4)} />
                      </Tabs>
                    </Box>
                  </Paper>

                  <TabPanel value={activeTab} index={0}>
                    <div className="deleted-form-content">
                      <NursesAssessmentform1
                        data={form1Data}
                        setFormValues={setForm1Data}
                        onSubmit={() => {}}
                        buttons={[]}
                        isEdit={true}
                      />
                    </div>
                  </TabPanel>

                  <TabPanel value={activeTab} index={1}>
                    <div className="deleted-form-content">
                      <NursesAssessmentForm2
                        data={form2Data}
                        setFormValues={setForm2Data}
                        onSubmit={() => {}}
                        buttons={[]}
                      />
                    </div>
                  </TabPanel>

                  <TabPanel value={activeTab} index={2}>
                    <div className="deleted-form-content">
                      <NursesAssessmentForm3
                        data={form3Data}
                        setFormValues={setForm3Data}
                        onSubmit={() => {}}
                        buttons={[]}
                      />
                    </div>
                  </TabPanel>

                  <TabPanel value={activeTab} index={3}>
                    <div className="deleted-form-content">
                      <NursesAssessmentForm4
                        data={form4Data}
                        setFormValues={setForm4Data}
                        onSubmit={() => {}}
                        buttons={[]}
                      />
                    </div>
                  </TabPanel>

                  <TabPanel value={activeTab} index={4}>
                    <div className="deleted-form-content">
                      <DynamicForm
                        fields={formElements}
                        data={formData}
                        onSubmit={() => {}}
                        buttons={[]}
                        setFormValues={setFormData}
                        disabled={true}
                      />
                    </div>
                  </TabPanel>
                </Box>

                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mt: 3,
                    px: 2,
                  }}
                >
                  <Box sx={{display: 'flex', gap: 2}}>
                    <Button
                      variant='outlined'
                      disabled={activeTab === 0}
                      onClick={() => setActiveTab(activeTab - 1)}
                      sx={{minWidth: '100px'}}
                    >
                      Previous
                    </Button>
                    <Button
                      variant='outlined'
                      disabled={activeTab === 4}
                      onClick={() => setActiveTab(activeTab + 1)}
                      sx={{minWidth: '100px'}}
                    >
                      Next
                    </Button>
                  </Box>

                  <Button
                    variant='outlined'
                    color='primary'
                    onClick={() => history.push('/deleted-notes/nurses-notes/list')}
                    sx={{minWidth: '100px'}}
                  >
                    Cancel
                  </Button>
                </Box>
              </>
            )}
          </>
        }
      />
    </LocalizationProvider>
  )
}
